<template>
  <div class="wrapper">
    <div class="container">
      <div class="address">
        Unit 4 & 5 ,33Stockwell Place,Archerfield QLD 4108 <br>
        www.fastgo.com.au <br>
        +61 7 3103 2888
        <div></div>
        <div></div>
      </div>
      <div class="content">
        <h1>澳大利亚到中国 快件包裹打包规定</h1>
        <h3>贵重物品请面单或电子单 备注每个包裹的价值。 包裹总价值不超过200澳币</h3>
        <div class="table clearfix">
          <div class="table-left">
            <table border="1" cellpadding="0" cellspacing="0" width="570px">
              <tr>
                <th style="width: 150px">商品类别</th>
                <th>打包规则 <span class="important">包裹总价值低于$200</span></th>
                <th>备注：请参考官方原价值打包。<span class="important">特价打折产品海关一般不予认可哦</span></th>
              </tr>
              <tr>
                <td rowspan="2">婴儿奶粉/特殊配方奶粉</td>
                <td rowspan="2">数量≤3罐（4罐可发，联系询价）</td>
                <td>3罐及以上奶粉不能混其他物品</td>
              </tr>
              <tr>
                <td>1罐可混装5个保健品，2罐可混装3个保健品。称重计费</td>
              </tr>
              <tr>
                <td>成人奶粉</td>
                <td>数量≦8 袋（羊奶粉及蓝胖子奶粉，只能数量≦6</td>
                <td>6袋/8袋成人奶粉不能混其他物品</td>
              </tr>
              <tr>
                <td>低价食品</td>
                <td>数量≦15 个</td>
                <td>巧克力，米粉等普通食品（<span class="important">肉泥，罐头，乳酪，酸奶类，种子类不可以发</span>）</td>
              </tr>
              <tr>
                <td>保健品</td>
                <td>数量≦10 个</td>
                <td>排油丸，花青素≦2（<span class="important">传销品牌不可发</span>）</td>
              </tr>
              <tr>
                <td>低价洗护日用品</td>
                <td>数量≦12个</td>
                <td>肥皂，绵羊油洗护，单价≦$3/个</td>
              </tr>
              <tr>
                <td>洗护用品（非奢侈品牌）</td>
                <td>数量≦8 个</td>
                <td>建议单价≦$6/个</td>
              </tr>
              <tr>
                <td rowspan="2">护肤品（非奢侈品牌</td>
                <td rowspan="2">数量≦6 个</td>
                <td>高于50AUD小于100AUD的 可以发2个</td>
              </tr>
              <tr>
                <td>低于50AUD的可以发4-6个</td>
              </tr>
              <tr>
                <td colspan="3" style="text-align: left">备注：50 澳币以上的护肤品（雅诗兰黛，香奈儿, 兰蔻，SKII，AESOP， 娇韵诗，茱莉蔻等国际知名品牌）包装标准限 1个包裹1个</td>
              </tr>
              <tr>
                <td colspan="3" style="text-align: left"><span class="important">知名品牌护肤品套装/化妆品套装不能发，含濒危灭绝生物成分的物品不可以发，例如鲟鱼子， 鱼子酱，羊胎素成分等护肤品。</span></td>
              </tr>
              <tr>
                <td>护肤品套装（非奢侈品牌）</td>
                <td>数量≦1个</td>
                <td>建议包裹总价值不超过50AUD，低价SUKIN三件套最多2套，价值大于50澳币护肤品套装，重量计费+价值20%的税</td>
              </tr>
              <tr>
                <td>化妆品（非奢侈品牌）</td>
                <td>数量≦3个</td>
                <td>指眼影，粉底，口红等单价低于$50，高于50AUD的一个包裹1个</td>
              </tr>
              <tr>
                <td>玩偶/玩具</td>
                <td>数量≦3个</td>
                <td>物品总价值低于$50</td>
              </tr>
              <tr>
                <td>玩具积木（长宽高超过40cm有体积重）</td>
                <td>数量≦1个</td>
                <td>价值50AUD以下，按杂货重量计费。价值<span class="important">50-100AUD</span>，重量计费<span class="important">+10AUD</span>税费。价值大于<span class="important">100-200AUD</span>，重量计费<span class="important">+15AUD</span>税费</td>
              </tr>
              <tr>
                <td  rowspan="3">香水</td>
                <td  rowspan="3">数量≦1个</td>
                <td>价值低于40AUD，免税按杂货重量计费</td>
              </tr>
              <tr>
                <td>价值<span class="important">40-120AU</span>，重量计费+税金<span class="important">15AUD</span></td>
              </tr>
              <tr>
                <td>价值大于<span class="important">120AUD以上不收</span></td>
              </tr>
              <tr>
                <td  rowspan="3">首饰</td>
                <td  rowspan="3">数量≦1个</td>
                <td>低于50澳币的杂货计费</td>
              </tr>
              <tr>
                <td>价值<span class="important">50-100AUD</span>，杂货重量计费<span class="important">+10AUD税费</span></td>
              </tr>
              <tr>
                <td>价值大于<span class="important">100-200AUD</span>，杂货重量计费<span class="important">+15AUD税费</span></td>
              </tr>
              <tr>
                <td>手表</td>
                <td>数量≦1个</td>
                <td>低于50澳币的杂货计费, <span class="important">大于50AUD-200AUD</span>，杂货计费+<span class="important">发票 *15%</span>的税费</td>
              </tr>
              <tr>
                <td>包包</td>
                <td>数量≦1个</td>
                <td>低于50AUD杂货重量计费 价值<span class="important">50-100AUD</span>，重量计费<span class="important">+10AUD</span>税费；<span class="important">大于100AUD-200AUD</span>，杂货重量计费+<span class="important">发票15%计税</span>。</td>
              </tr>
              <tr>
                <td  rowspan="3">家用小电器</td>
                <td  rowspan="3">数量≦1个</td>
                <td>低于50AUD的杂货计费</td>
              </tr>
              <tr>
                <td>价值<span class="important">50-100AUD</span>，杂货重量计费<span class="important">+10AUD税费</span></td>
              </tr>
              <tr>
                <td>价值<span class="important">大于100-200AUD</span>，杂货重量计费<span class="important">+15 AUD税费</span></td>
              </tr>
              <tr>
                <td  rowspan="2">电动牙刷</td>
                <td  rowspan="2">数量≦1个</td>
                <td>成人电动牙刷1个包裹1个</td>
              </tr>
              <tr>
                <td>儿童电动牙刷可 2 个1个包裹</td>
              </tr>
              <tr>
                <td  rowspan="3">鞋子（品牌、型号、货号、价值）</td>
                <td  rowspan="3">数量≦1个</td>
                <td><span class="important">普通帆布鞋，豆豆鞋，运动鞋类50AUD以内杂货计费</span>，大于250-400RMB 的重量计费+税<span class="important">10AUD</span>，400RMB以上重量计费+<span class="important">价值*20%</span>的税费</td>
              </tr>
              <tr>
                <td><span class="important">靴类40AUD以内杂货计费</span>，大于200-400RMB，重量计费+税<span class="important">15AUD</span>，400RMB以上，重量计费+<span class="important">价值*20%的</span>税费</td>
              </tr>
              <tr>
                <td><span class="important">鞋子折扣价低于以上打包要求无税价值的，关口查验后有产生税金的需客户自理</span></td>
              </tr>
              <tr>
                <td  rowspan="3">单薄衣服/帽子/围巾</td>
                <td  rowspan="3">数量≦3个（限包裹总价值50澳币）</td>
                <td>3件内总价值不超50AUD，按杂货重量计费</td>
              </tr>
              <tr>
                <td>一件价值<span class="important">50-100AUD</span>之间，一个包裹一件，<span class="important">杂货重量计费+10AUD税费</span></td>
              </tr>
              <tr>
                <td>一件价值<span class="important">大于100-200AUD</span>之间，一个包裹一件<span class="important">杂货重量计费+15AUD税费</span>。</td>
              </tr>
            </table>

          </div>
          <div class="table-right">
            <table border="1" cellpadding="0" cellspacing="0" width="570px">
              <tr>
                <td  rowspan="3">被子/生活用品<span class="important">可塞进六罐箱</span>。</td>
                <td  rowspan="3">数量≦1个</td>
                <td>价值低于50AUD，按杂货重量计费；</td>
              </tr>
              <tr>
                <td>一件价值<span class="important">50-100AUD</span>之间，一个包裹一件，杂货重量计费+10AUD税费。</td>
              </tr>
              <tr>
                <td>一件价值<span class="important">大于100-200AUD</span>之间，一个包裹一件<span class="important">杂货重量计费+15AUD税费。</span></td>
              </tr>
              <tr>
                <td colspan="3" class="text-center">被子，一个包裹一件。可塞进六罐箱，按实际重量计费；<span class="important">如果塞不进六罐箱，按体积重计费</span>。长*宽*高/5000 单位cm</td>
              </tr>
              <tr>
                <td colspan="3" class="text-center">杂货包裹重量不超过  3.5KG <span class="important">包裹价值低于$200</span></td>
              </tr>
              <tr>
                <td colspan="3">混装  打包规则</td>
              </tr>
              <tr style="height: 80px">
                <td  >保健品/食品混装</td>
                <td  colspan="2">数量≦10个</td>
              </tr>
              <tr style="height: 80px">
                <td >保健品/洗护日用品混装</td>
                <td  colspan="2">数量≦8个</td>
              </tr>
              <tr style="height: 80px">
                <td >保健品/护肤品</td>
                <td  colspan="2">数量≦6个</td>
              </tr>
              <tr style="height: 80px">
                <td >保健品/化妆品</td>
                <td  colspan="2">数量≦4个</td>
              </tr>
              <tr style="height: 80px">
                <td >化妆品/护肤品</td>
                <td  colspan="2">数量≦4个</td>
              </tr>
              <tr>
                <td colspan="3" class="text-center">杂货包裹重量不超过 3.5kg <span class="important">包裹价值低于$200</span> </td>
              </tr>
              <tr>
                <td colspan="3" class="text-center">**不在打包规则上的特殊商品请咨询 FASTGO 客服或者财务 </td>
              </tr>
              <tr>
                <td colspan="3" >
                  <span class="important">为了包裹能更好更快的完成清关，请务必提供上传有效收件人身份证正反面图片，包裹内件请填写真实内件的 品牌 规格和型号货号数量哦</span>。避免因查验申报不符造成的清关延误以及额外的税金等（需客户承担）。
                  护肤（化妆）品，衣服 ，鞋子，包包，饰品，玩具类。请务必保留当时购物价值小票上传客户群，便于关口核价和理赔。一般需提供真实有效的购买凭证小票或关口认可的网上截图（带网址的图片）或者链接 （链接需可有效查询到。如果特价打折没了关口税金参考原价！！！<span class="important">一般建议不发这种特价打折的或者经过客户允许我们可以尝试安排发走，被查验到税金由客户承担哦</span>。）
                </td>
              </tr>
            </table>

            <div class="other">
              <div class="other-title">其他注意事项：</div>
              <div class="other-item clearfix">
                <div class="item-title">□ 禁运物品:</div>
                <div class="item-content">易燃易爆航空管制品，肉制品，生鲜，干货，旧物品，液态奶，奶酪芝士，鸡蛋制品， 猫狗粮，烟草、处方药（胃药、银杏片），加工的种子制品（生咖啡豆，奇亚籽，麦麸，藜麦，薰衣草小熊等)，未加工的动物皮毛，证书文件，合同，光盘，文物，钞票硬币，等。</div>
              </div>
              <div class="other-item clearfix">
                <div class="item-title">□ 运单填写:</div>
                <div class="item-content">为了保证清关和赔偿效率，请如实填写物品的商品名称 和规格   （重量，粒数和容量）</div>
              </div>
              <div class="other-item clearfix">
                <div class="item-title">□ 赔付:</div>
                <div class="item-content">符合打包规范的包裹（不含特殊物品），赔偿总价不高于$200。客户有责任对包裹内件进行如实申报，如包裹内件不符合本规定，或物品包装以及保护方式不符合规定， 则我公司不予赔偿，因此产生的破损，丢失，税金，海关罚款以及其他衍生费用均由发货人承担。</div>
              </div>
              <div class="other-item clearfix">
                <div class="item-title">□ 打包规范:</div>
                <div class="item-content" style="font-weight: bolder">所有包裹内件请尽量用泡泡纸保护，务必确保包裹内空隙被填充满。</div>
              </div>
              <div class="other-item clearfix">
                <div class="item-title">□ 特殊物品:</div>
                <div class="item-content" style="font-weight: bolder">S26 婴儿奶粉，雅培系列糖尿病奶粉，孕妇奶粉，大小安素，袋装成人奶粉，蓝胖子奶粉，包装材料为玻璃瓶的商品，所有液体产品和洗护类产品，口红，因气温变化容易损坏的商品 请妥善包装，如有破损，不予赔偿。</div>
              </div>
              <div class="other-item clearfix">
                <div class="item-title">□ 化妆品特指:</div>
                <div class="item-content">口红，眼影，粉底 等彩妆类物品，不能邮寄彩妆礼盒（含彩妆赠品礼盒）。</div>
              </div>
              <div class="other-item clearfix">
                <div style="text-align: left">□ 护肤品/保健品 套装 按照内件数量计算，并且需要填写包裹内件名称。</div>
              </div>
              <div class="other-item clearfix">
                <div style="text-align: left">□ 发往香港、台湾、澳门的包裹<span class="important">不接受液体，粉末，和带有电池的小家电</span>。</div>
              </div>
              <div class="other-item clearfix">
                <div style="text-align: left">□ 8袋 A2/德运成人奶粉发货羊奶粉及蓝胖子奶粉除外），新疆、西藏、青海，港澳台地区暂时不收。</div>
              </div>
              <div class="other-item clearfix">
                <div style="text-align: left">□ 泡重物品按照能够放入一个 6 罐箱为准，体积重量按照长宽高边长有一边超过40cm ，按照体积重量计费收取。</div>
              </div>
            </div>

            <div class="company clearfix">
              <div>FASTGO速派 <br>2019/12/12</div>
              <img :src="commonData?commonData.fastgoCode[0].logo_url:''" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "pack",
    computed: {
      ...mapState({
        commonData: state => state.commonData,
      }),
    },
    mounted() {

    }
  }
</script>

<style scoped lang="scss">
  .wrapper{
    width: 1183px;
  }
  .container{
    width: 1183px;
  }
  .address {
    font-weight: bolder;
    font-size: 18px;
    text-align: left;
  }

  .address div:nth-last-child(2) {
    width: 100%;
    background: $bg-color;
    height: 1px;
    margin-bottom: 1px;
    margin-top: 17px;
  }

  .address div:nth-last-child(1) {
    width: 100%;
    background: $bg-color;
    height: 3px;
    margin-bottom: 70px;
  }
  .content{
    margin-bottom: 50px;
  }
  .content h3 {
    color: red;
    line-height: 25px;
  }

  .table-left {
    width: 570px;
    float: left;
    margin-top: 42px;
  }

  .table-right {
    float: right;
    width: 570px;
    margin-top: 42px;
  }
  .table-left table td, .table-right table td{
    padding: 8px;
    color: #000;
    font-weight: bolder;
  }
  .important{
    color: red;

  }
  .other-item{
    margin-bottom: 10px;
  }
  .other-title{
    font-size: 30px;
    color: rgb(5,7,7);
    text-align: left;
    font-weight: bolder;
    margin-top: 30px;
    margin-bottom: 10px;
  }
  .item-title{
    float: left;
    width: 18%;
    text-align: left;
    line-height: 32px;
  }
  .item-content{
    float: left;
    width: 82%;
    text-align: left;
    line-height: 32px;
  }
  .company{
    margin-top: 30px;
  }
  .company div{
    float: right;
    margin-top: 90px;
    font-weight: bolder;
  }
  .company img{
    float: right;
    width: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/view/PageService/components/pack.vue